package org.braunequip.web.components.models

import kotlinx.serialization.Serializable


enum class DieselType(val literal: String) {
    clear("clear"),
    dyed("dyed");

    companion object {
        fun fromLiteral(literal: String): DieselType? {
            return entries.find { it.literal == literal.lowercase() }
        }
    }
}


@Serializable
data class DieselFuelLogDTO(
    var id: Int? = null,
    var dieselType: DieselType? = DieselType.dyed,
    var name: String = "",
    var date: String = "",
    var equipmentId: String = "",
    var startingMeter: Int = 0,
    var endingMeter: Int = 0,
    var totalGallons: Int = 0,
    var signature: String? = null,
    var createdAt: String? = null
)
